<template>
    <div class="field is-horizontal">
        <div class="field-label">
            <label class="label">Win max:</label>
        </div>
        <div class="field-body">
            <div class="field">
                <div class="control">
                    <div class="select">
                        <select v-model="groupMaxWins">
                            <option v-for="win in getMaxWins">{{ win }}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['bid'],
        components: {

        },
        data() {
            return {

            }
        },
        computed: {
            getMaxWins() {
                return this.$store.getters.getGroupSettings.max_group_bids
            },
            groupMaxWins: {
                get() {
                    return this.$store.getters.getSelectedGroup.max_wins
                },
                set(value) {
                    this.$store.dispatch('changeSelectedGroupFieldValue',  {field: 'max_wins', value: value})
                }
            }
        },
        methods: {


        },
        mounted() {

        }
    }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Auctions/Lot/Modal/GroupMaxWins.vue